import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

export class ExportManager<T extends Record<string, any>> {
  static async exportExcel<T extends Record<string, any>>(
    data: T[],
    fileName = "data.xlsx",
  ) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("data");

    if (data.length > 0) {
      // Define columns dynamically from object keys
      worksheet.columns = Object.keys(data[0]).map((key) => ({
        header: key,
        key,
        width: 20,
      }));

      // Add rows
      data.forEach((item) => worksheet.addRow(item));
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(link.href);
  }

  static async exportCSV<T extends Record<string, any>>(
    data: T[],
    fileName = "data.csv",
  ) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("data");

    if (data.length > 0) {
      worksheet.columns = Object.keys(data[0]).map((key) => ({
        header: key,
        key,
        width: 20,
      }));
      data.forEach((item) => worksheet.addRow(item));
    }

    const buffer = await workbook.csv.writeBuffer();
    const blob = new Blob([buffer], { type: "text/csv;charset=utf-8;" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(link.href);
  }

  static async exportPDF<T extends Record<string, any>>(
    data: T[],
    fileName = "data.pdf",
  ) {
    const doc = new jsPDF();

    if (data.length > 0) {
      const headers = Object.keys(data[0]);

      const rows = data.map((item) => headers.map((key) => item[key]));

      autoTable(doc, {
        head: [headers],
        body: rows,
        styles: { fontSize: 10 },
        headStyles: { fillColor: [22, 160, 133] },
      });
    } else {
      doc.text("No data available", 10, 10);
    }

    doc.save(fileName);
  }
}
